module.exports = "/img/vdf_bg.jpeg?91f275a0ffbd031b7bb9c3c822d7577e";